var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoughie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34961 0.777344C4.55273 0.599609 4.85742 0.599609 5.06055 0.777344C5.74609 1.4375 6.40625 2.14844 7.01562 2.91016C7.29492 2.55469 7.625 2.14844 7.95508 1.81836C8.1582 1.64062 8.46289 1.64062 8.66602 1.81836C9.55469 2.65625 10.291 3.77344 10.8242 4.81445C11.332 5.85547 11.6875 6.92188 11.6875 7.6582C11.6875 10.9082 9.14844 13.625 6 13.625C2.80078 13.625 0.3125 10.9082 0.3125 7.6582C0.3125 6.69336 0.744141 5.5 1.45508 4.30664C2.16602 3.11328 3.15625 1.86914 4.34961 0.777344ZM6.02539 11.1875C6.68555 11.1875 7.24414 11.0098 7.77734 10.6543C8.84375 9.91797 9.12305 8.41992 8.48828 7.25195C8.38672 7.02344 8.08203 6.99805 7.92969 7.20117L7.26953 7.9375C7.11719 8.14062 6.8125 8.14062 6.66016 7.9375C6.22852 7.4043 5.49219 6.43945 5.06055 5.90625C4.9082 5.70312 4.60352 5.70312 4.42578 5.90625C3.5625 6.97266 3.13086 7.6582 3.13086 8.41992C3.15625 10.1719 4.42578 11.1875 6.02539 11.1875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoughie);
export default ForwardRef;